var $ = jQuery;

function init() {
  // var transEndEventNames = {
  //   'WebkitTransition' : 'webkitTransitionEnd',// Saf 6, Android Browser
  //   'MozTransition'    : 'transitionend',      // only for FF < 15
  //   'transition'       : 'transitionend'       // IE10, Opera, Chrome, FF 15+, Saf 7+
  // };

  // var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];

  const ARTICLE_TRACK = '.article__sticky-track';
  const ARTICLE_BODY = '.article__body-copy';

  initReadMore();

  function initReadMore() {
    binds();
    setArticleHeight();
  }

  function binds() {
    $(document).on('click', '.article-body__read-more', openArticle);
    $(window).on('resize',setArticleHeight);
  }

  function setArticleHeight() {
    $(ARTICLE_TRACK).each(function() {
      let $child = $(this).find(ARTICLE_BODY);
      if($(this).attr('data-height') === undefined) {
        let bodyHeight = $child.outerHeight(true);
        $(this).attr('data-height', bodyHeight);
      }
    });
  }

  function openArticle(e) {
    setArticleHeight();
    let bodyHeight = $(this).prev().attr('data-height');
    let $articleBody = $(this).prev();

    $articleBody.addClass('_article-open').css({ 'height': bodyHeight });
    $(this).addClass('_inactive');

    $articleBody.on('webkitTransitionEnd transitionend', function(e) {
      $(this).css({'height' :'auto' , 'overflow' : 'visible'});
      $(this).trigger('initAllArticle');
    });

  }
}

export { init as init };
